import React from 'react';

import {Table,ButtonGroup,Button} from 'react-bootstrap';

import Icon from '../../../../components/Icon';

const PayoutsTable = (props) => {
    let {data} = props;
    data = data ? data : [];

    const uniqueCountries = data.reduce((countriesArr, item) => {
        Object.keys(item.countries).forEach(cc => {
            if(!countriesArr.includes(cc)) {
                countriesArr.push(cc);
            }
        })

        return countriesArr;
    },[]);

    const uniqueCountriesTh = uniqueCountries.map(cc => <th key={cc}>{cc}</th>);

    const rows = data.map(item => {
        const {countries} = item;
        const payoutsRows = uniqueCountries.map(cc => {
            return (
                <td key={cc}>{countries[cc]}</td>
            );
        });

        return (
            <tr key={item.affid}>
                <td>{item.name}</td>
                <td>{item.affid}</td>
                {payoutsRows}
                <td>
                    <ButtonGroup>
                        <Button bsStyle="info" onClick={() => props.onUpdateBtnClick(item.affid)}>Update</Button>
                        <Button bsStyle="warning" onClick={() => props.onUpdateBtnClick(item.affid)}>Duplicate</Button>
                        <Button bsStyle="danger" onClick={() => props.onRemoveBtnClick(item.affid)}><Icon name="times"/> Remove</Button>
                    </ButtonGroup>
                </td>
            </tr>
        );
    });

    return (
        <Table bordered responsive>
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Affid</th>
                    {uniqueCountriesTh}
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {rows}
            </tbody>
        </Table>
    );
}


export default PayoutsTable;


// WEBPACK FOOTER //
// ./src/scenes/Payouts/components/PayoutsTable/index.js